export default __webpack_public_path__ + "static/anthony-story-ac463ecfade015d5d3c3808f6e9501cc.png";